import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateAgentMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ agentId, model }: { agentId: string; model: any }) => {
			dispatch(uiActions.showSpinnerOverlay());
			return merchantsService.updateAgent(agentId, model);
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateAgentMutation;
